export const REFERENCE_RELATES_TO = "relatesToRef";
